require('./dist/smart-table.js');
module.exports = 'smart-table';


//////////////////
// WEBPACK FOOTER
// ./~/angular-smart-table/index.js
// module id = 123
// module chunks = 14